import * as z from 'zod';
import { get, keys, isString, map } from 'lodash';
import debug from 'debug';
import { hooks } from './hooks';
import * as YAML from 'yaml';
const log = debug('itp:core:errors');
function isAxiosError(payload) {
    return payload['isAxiosError'] === true;
}
function isNetworkError(payload) {
    return get(payload, 'message') === 'Network Error';
}
function isJSONResponse(resp) {
    return resp.headers['content-type'].includes('application/json');
}
function isAbv(value) {
    return (value && value instanceof ArrayBuffer && value.byteLength !== undefined);
}
function responseJSON(response) {
    if (isAbv(response.data)) {
        try {
            return JSON.parse(new TextDecoder().decode(response.data));
        }
        catch (error) {
            console.error('failed to parse response data as JSON', error);
        }
    }
    return response.data;
}
function humanizeAxiosError(e) {
    if (isNetworkError(e)) {
        return { error: e.message };
    }
    if (!e.response || !isJSONResponse(e.response)) {
        return { error: e };
    }
    const title = `${e.response.status} ${e.response.statusText}`, message = e.message, data = responseJSON(e.response);
    const errorMessage = get(data, 'message', null), errorCode = get(data, 'code', null);
    if (errorMessage && errorCode) {
        return {
            title: errorCode,
            message: errorMessage
        };
    }
    return {
        title,
        message: message,
        details: humanizeDetails(data)
    };
}
function humanizeDetails(data) {
    if (isString(data)) {
        return data;
    }
    if (isValidationErrorContent(data)) {
        if (data.detail.length === 1) {
            return humanValidationError(data.detail[0]);
        }
        return YAML.stringify(map(data.detail, humanValidationError));
    }
    const keys_ = keys(data);
    if (keys_.length === 1) {
        data = data[keys_[0]];
    }
    return YAML.stringify(data);
}
const ValidationErrorSchema = z.object({
    type: z.literal('ValidationError'),
    loc: z.array(z.string()),
    msg: z.string()
});
const ValidationErrorContentSchema = z.object({
    detail: z.array(ValidationErrorSchema)
});
function isValidationErrorContent(value) {
    const p = ValidationErrorContentSchema.safeParse(value);
    log('isValidationErrorContent? %o => %o', value, p);
    return p.success;
}
function humanValidationError(err) {
    return `${err.loc.join('.')}: ${err.msg}`;
}
export function initializeErrorModalOptionsHookHandler() {
    hooks.errorModalOptionsHook.add(opts => {
        if (opts.error && isAxiosError(opts.error)) {
            return humanizeAxiosError(opts.error);
        }
        return opts;
    });
}
//# sourceMappingURL=errors.js.map